/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * PalNote API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountDeletion,
  ApiError,
  Appointment,
  AppointmentDetail,
  AppointmentInput,
  AppointmentUpdate,
  AuditEventInput,
  AuditEventResult,
  AuditLog,
  CheckoutConfirmInput,
  CheckoutInput,
  CheckoutUrl,
  ClinicianProfile,
  ClinicianProfileUpdate,
  DashboardStats,
  DeleteAccountParams,
  GetIntakePrefillParams,
  HealthStatus,
  Intake,
  IntakeDetail,
  IntakeInput,
  IntakePrefillResult,
  IntakeTemplate,
  IntakeTemplateDuplicateInput,
  IntakeTemplateInput,
  ListAppointmentsParams,
  ListAuditLogsParams,
  ListIntakesParams,
  ListNotesParams,
  ListPatientsParams,
  MeResponse,
  Member,
  MemberRole,
  MemberRoleUpdate,
  Note,
  NoteInput,
  NoteUpdate,
  OpenaiConversation,
  OpenaiConversationInput,
  OpenaiConversationWithMessages,
  OpenaiError,
  OpenaiImageInput,
  OpenaiImageOutput,
  OpenaiMessage,
  OpenaiMessageInput,
  OutcomeMeasureRecord,
  Patient,
  PatientExport,
  PatientInput,
  PatientUpdate,
  PreVisitSummary,
  Provider,
  ProviderInput,
  ProviderUpdate,
  PublicIntake,
  PublicIntakeChatInput,
  PublicIntakeChatResult,
  PublicIntakeModeInput,
  PublicIntakeModeResult,
  PublicIntakeSaveInput,
  PublicIntakeSaveResult,
  PublicIntakeSubmitResult,
  RetentionSettings,
  RetentionSettingsUpdate,
  SecuritySettings,
  SecuritySettingsUpdate,
  SendAppointmentIntakeInput,
  SubscriptionStatus,
  TranscribeInput,
  TranscribeResult
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListPatientsUrl = (params?: ListPatientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/patients?${stringifiedParams}` : `/api/patients`
}

/**
 * @summary List all patients for authenticated user
 */
export const listPatients = async (params?: ListPatientsParams, options?: RequestInit): Promise<Patient[]> => {

  return customFetch<Patient[]>(getListPatientsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPatientsQueryKey = (params?: ListPatientsParams,) => {
    return [
    `/api/patients`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPatientsQueryOptions = <TData = Awaited<ReturnType<typeof listPatients>>, TError = ErrorType<unknown>>(params?: ListPatientsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPatients>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPatientsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPatients>>> = ({ signal }) => listPatients(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPatients>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPatientsQueryResult = NonNullable<Awaited<ReturnType<typeof listPatients>>>
export type ListPatientsQueryError = ErrorType<unknown>


/**
 * @summary List all patients for authenticated user
 */

export function useListPatients<TData = Awaited<ReturnType<typeof listPatients>>, TError = ErrorType<unknown>>(
 params?: ListPatientsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPatients>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPatientsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePatientUrl = () => {




  return `/api/patients`
}

/**
 * @summary Create a new patient
 */
export const createPatient = async (patientInput: PatientInput, options?: RequestInit): Promise<Patient> => {

  return customFetch<Patient>(getCreatePatientUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patientInput,)
  }
);}




export const getCreatePatientMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPatient>>, TError,{data: BodyType<PatientInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPatient>>, TError,{data: BodyType<PatientInput>}, TContext> => {

const mutationKey = ['createPatient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPatient>>, {data: BodyType<PatientInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPatient(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePatientMutationResult = NonNullable<Awaited<ReturnType<typeof createPatient>>>
    export type CreatePatientMutationBody = BodyType<PatientInput>
    export type CreatePatientMutationError = ErrorType<unknown>

    /**
 * @summary Create a new patient
 */
export const useCreatePatient = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPatient>>, TError,{data: BodyType<PatientInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPatient>>,
        TError,
        {data: BodyType<PatientInput>},
        TContext
      > => {
      return useMutation(getCreatePatientMutationOptions(options));
    }

export const getGetPatientUrl = (id: number,) => {




  return `/api/patients/${id}`
}

/**
 * @summary Get patient by ID
 */
export const getPatient = async (id: number, options?: RequestInit): Promise<Patient> => {

  return customFetch<Patient>(getGetPatientUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPatientQueryKey = (id: number,) => {
    return [
    `/api/patients/${id}`
    ] as const;
    }


export const getGetPatientQueryOptions = <TData = Awaited<ReturnType<typeof getPatient>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatient>>> = ({ signal }) => getPatient(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPatientQueryResult = NonNullable<Awaited<ReturnType<typeof getPatient>>>
export type GetPatientQueryError = ErrorType<ApiError>


/**
 * @summary Get patient by ID
 */

export function useGetPatient<TData = Awaited<ReturnType<typeof getPatient>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPatientQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePatientUrl = (id: number,) => {




  return `/api/patients/${id}`
}

/**
 * @summary Update a patient
 */
export const updatePatient = async (id: number,
    patientUpdate: PatientUpdate, options?: RequestInit): Promise<Patient> => {

  return customFetch<Patient>(getUpdatePatientUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patientUpdate,)
  }
);}




export const getUpdatePatientMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePatient>>, TError,{id: number;data: BodyType<PatientUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePatient>>, TError,{id: number;data: BodyType<PatientUpdate>}, TContext> => {

const mutationKey = ['updatePatient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePatient>>, {id: number;data: BodyType<PatientUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePatient(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePatientMutationResult = NonNullable<Awaited<ReturnType<typeof updatePatient>>>
    export type UpdatePatientMutationBody = BodyType<PatientUpdate>
    export type UpdatePatientMutationError = ErrorType<ApiError>

    /**
 * @summary Update a patient
 */
export const useUpdatePatient = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePatient>>, TError,{id: number;data: BodyType<PatientUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePatient>>,
        TError,
        {id: number;data: BodyType<PatientUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePatientMutationOptions(options));
    }

export const getDeletePatientUrl = (id: number,) => {




  return `/api/patients/${id}`
}

/**
 * @summary Delete a patient
 */
export const deletePatient = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePatientUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePatientMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePatient>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePatient>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePatient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePatient>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePatient(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePatientMutationResult = NonNullable<Awaited<ReturnType<typeof deletePatient>>>

    export type DeletePatientMutationError = ErrorType<unknown>

    /**
 * @summary Delete a patient
 */
export const useDeletePatient = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePatient>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePatient>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePatientMutationOptions(options));
    }

export const getListPatientNotesUrl = (id: number,) => {




  return `/api/patients/${id}/notes`
}

/**
 * @summary List all notes for a patient
 */
export const listPatientNotes = async (id: number, options?: RequestInit): Promise<Note[]> => {

  return customFetch<Note[]>(getListPatientNotesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPatientNotesQueryKey = (id: number,) => {
    return [
    `/api/patients/${id}/notes`
    ] as const;
    }


export const getListPatientNotesQueryOptions = <TData = Awaited<ReturnType<typeof listPatientNotes>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPatientNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPatientNotesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPatientNotes>>> = ({ signal }) => listPatientNotes(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPatientNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPatientNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listPatientNotes>>>
export type ListPatientNotesQueryError = ErrorType<unknown>


/**
 * @summary List all notes for a patient
 */

export function useListPatientNotes<TData = Awaited<ReturnType<typeof listPatientNotes>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPatientNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPatientNotesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListPatientOutcomeMeasuresUrl = (id: number,) => {




  return `/api/patients/${id}/outcome-measures`
}

/**
 * Returns the recorded outcome-measure scores for a patient, ordered oldest-first, so the clinician can chart progress over time. Scoped to the authenticated clinician's own patients.
 * @summary List standardized outcome-measure history for a patient
 */
export const listPatientOutcomeMeasures = async (id: number, options?: RequestInit): Promise<OutcomeMeasureRecord[]> => {

  return customFetch<OutcomeMeasureRecord[]>(getListPatientOutcomeMeasuresUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPatientOutcomeMeasuresQueryKey = (id: number,) => {
    return [
    `/api/patients/${id}/outcome-measures`
    ] as const;
    }


export const getListPatientOutcomeMeasuresQueryOptions = <TData = Awaited<ReturnType<typeof listPatientOutcomeMeasures>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPatientOutcomeMeasures>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPatientOutcomeMeasuresQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPatientOutcomeMeasures>>> = ({ signal }) => listPatientOutcomeMeasures(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPatientOutcomeMeasures>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPatientOutcomeMeasuresQueryResult = NonNullable<Awaited<ReturnType<typeof listPatientOutcomeMeasures>>>
export type ListPatientOutcomeMeasuresQueryError = ErrorType<unknown>


/**
 * @summary List standardized outcome-measure history for a patient
 */

export function useListPatientOutcomeMeasures<TData = Awaited<ReturnType<typeof listPatientOutcomeMeasures>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPatientOutcomeMeasures>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPatientOutcomeMeasuresQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListNotesUrl = (params?: ListNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notes?${stringifiedParams}` : `/api/notes`
}

/**
 * @summary List all notes for authenticated user
 */
export const listNotes = async (params?: ListNotesParams, options?: RequestInit): Promise<Note[]> => {

  return customFetch<Note[]>(getListNotesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotesQueryKey = (params?: ListNotesParams,) => {
    return [
    `/api/notes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotesQueryOptions = <TData = Awaited<ReturnType<typeof listNotes>>, TError = ErrorType<unknown>>(params?: ListNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotes>>> = ({ signal }) => listNotes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listNotes>>>
export type ListNotesQueryError = ErrorType<unknown>


/**
 * @summary List all notes for authenticated user
 */

export function useListNotes<TData = Awaited<ReturnType<typeof listNotes>>, TError = ErrorType<unknown>>(
 params?: ListNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNotesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateNoteUrl = () => {




  return `/api/notes`
}

/**
 * @summary Create a new SOAP note
 */
export const createNote = async (noteInput: NoteInput, options?: RequestInit): Promise<Note> => {

  return customFetch<Note>(getCreateNoteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      noteInput,)
  }
);}




export const getCreateNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNote>>, TError,{data: BodyType<NoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNote>>, TError,{data: BodyType<NoteInput>}, TContext> => {

const mutationKey = ['createNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNote>>, {data: BodyType<NoteInput>}> = (props) => {
          const {data} = props ?? {};

          return  createNote(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createNote>>>
    export type CreateNoteMutationBody = BodyType<NoteInput>
    export type CreateNoteMutationError = ErrorType<unknown>

    /**
 * @summary Create a new SOAP note
 */
export const useCreateNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNote>>, TError,{data: BodyType<NoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createNote>>,
        TError,
        {data: BodyType<NoteInput>},
        TContext
      > => {
      return useMutation(getCreateNoteMutationOptions(options));
    }

export const getGetNoteUrl = (id: number,) => {




  return `/api/notes/${id}`
}

/**
 * @summary Get a SOAP note by ID
 */
export const getNote = async (id: number, options?: RequestInit): Promise<Note> => {

  return customFetch<Note>(getGetNoteUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNoteQueryKey = (id: number,) => {
    return [
    `/api/notes/${id}`
    ] as const;
    }


export const getGetNoteQueryOptions = <TData = Awaited<ReturnType<typeof getNote>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNoteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNote>>> = ({ signal }) => getNote(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNote>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNoteQueryResult = NonNullable<Awaited<ReturnType<typeof getNote>>>
export type GetNoteQueryError = ErrorType<ApiError>


/**
 * @summary Get a SOAP note by ID
 */

export function useGetNote<TData = Awaited<ReturnType<typeof getNote>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetNoteQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateNoteUrl = (id: number,) => {




  return `/api/notes/${id}`
}

/**
 * @summary Update a SOAP note
 */
export const updateNote = async (id: number,
    noteUpdate: NoteUpdate, options?: RequestInit): Promise<Note> => {

  return customFetch<Note>(getUpdateNoteUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      noteUpdate,)
  }
);}




export const getUpdateNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNote>>, TError,{id: number;data: BodyType<NoteUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNote>>, TError,{id: number;data: BodyType<NoteUpdate>}, TContext> => {

const mutationKey = ['updateNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNote>>, {id: number;data: BodyType<NoteUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateNote(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateNote>>>
    export type UpdateNoteMutationBody = BodyType<NoteUpdate>
    export type UpdateNoteMutationError = ErrorType<unknown>

    /**
 * @summary Update a SOAP note
 */
export const useUpdateNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNote>>, TError,{id: number;data: BodyType<NoteUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateNote>>,
        TError,
        {id: number;data: BodyType<NoteUpdate>},
        TContext
      > => {
      return useMutation(getUpdateNoteMutationOptions(options));
    }

export const getDeleteNoteUrl = (id: number,) => {




  return `/api/notes/${id}`
}

/**
 * @summary Delete a SOAP note
 */
export const deleteNote = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteNoteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNote>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNote>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteNote(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNote>>>

    export type DeleteNoteMutationError = ErrorType<unknown>

    /**
 * @summary Delete a SOAP note
 */
export const useDeleteNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteNote>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteNoteMutationOptions(options));
    }

export const getDuplicateNoteUrl = (id: number,) => {




  return `/api/notes/${id}/duplicate`
}

/**
 * @summary Duplicate an existing SOAP note
 */
export const duplicateNote = async (id: number, options?: RequestInit): Promise<Note> => {

  return customFetch<Note>(getDuplicateNoteUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDuplicateNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateNote>>, TError,{id: number}, TContext> => {

const mutationKey = ['duplicateNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateNote>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  duplicateNote(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateNoteMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateNote>>>

    export type DuplicateNoteMutationError = ErrorType<unknown>

    /**
 * @summary Duplicate an existing SOAP note
 */
export const useDuplicateNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof duplicateNote>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDuplicateNoteMutationOptions(options));
    }

export const getTranscribeVisitUrl = () => {




  return `/api/visits/transcribe`
}

/**
 * @summary Transcribe audio and generate SOAP note via AI
 */
export const transcribeVisit = async (transcribeInput: TranscribeInput, options?: RequestInit): Promise<TranscribeResult> => {

  return customFetch<TranscribeResult>(getTranscribeVisitUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      transcribeInput,)
  }
);}




export const getTranscribeVisitMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transcribeVisit>>, TError,{data: BodyType<TranscribeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof transcribeVisit>>, TError,{data: BodyType<TranscribeInput>}, TContext> => {

const mutationKey = ['transcribeVisit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transcribeVisit>>, {data: BodyType<TranscribeInput>}> = (props) => {
          const {data} = props ?? {};

          return  transcribeVisit(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TranscribeVisitMutationResult = NonNullable<Awaited<ReturnType<typeof transcribeVisit>>>
    export type TranscribeVisitMutationBody = BodyType<TranscribeInput>
    export type TranscribeVisitMutationError = ErrorType<ApiError>

    /**
 * @summary Transcribe audio and generate SOAP note via AI
 */
export const useTranscribeVisit = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transcribeVisit>>, TError,{data: BodyType<TranscribeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof transcribeVisit>>,
        TError,
        {data: BodyType<TranscribeInput>},
        TContext
      > => {
      return useMutation(getTranscribeVisitMutationOptions(options));
    }

export const getGetDashboardStatsUrl = () => {




  return `/api/dashboard/stats`
}

/**
 * @summary Get dashboard statistics for the authenticated user
 */
export const getDashboardStats = async ( options?: RequestInit): Promise<DashboardStats> => {

  return customFetch<DashboardStats>(getGetDashboardStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardStatsQueryKey = () => {
    return [
    `/api/dashboard/stats`
    ] as const;
    }


export const getGetDashboardStatsQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardStats>>> = ({ signal }) => getDashboardStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardStats>>>
export type GetDashboardStatsQueryError = ErrorType<unknown>


/**
 * @summary Get dashboard statistics for the authenticated user
 */

export function useGetDashboardStats<TData = Awaited<ReturnType<typeof getDashboardStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMeUrl = () => {




  return `/api/me`
}

/**
 * @summary Get the authenticated user's identity and role
 */
export const getMe = async ( options?: RequestInit): Promise<MeResponse> => {

  return customFetch<MeResponse>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<unknown>


/**
 * @summary Get the authenticated user's identity and role
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetClinicianProfileUrl = () => {




  return `/api/me/profile`
}

/**
 * @summary Get the signed-in clinician's profile (backed by their default provider, auto-created on first access)
 */
export const getClinicianProfile = async ( options?: RequestInit): Promise<ClinicianProfile> => {

  return customFetch<ClinicianProfile>(getGetClinicianProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetClinicianProfileQueryKey = () => {
    return [
    `/api/me/profile`
    ] as const;
    }


export const getGetClinicianProfileQueryOptions = <TData = Awaited<ReturnType<typeof getClinicianProfile>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClinicianProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClinicianProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClinicianProfile>>> = ({ signal }) => getClinicianProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClinicianProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClinicianProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getClinicianProfile>>>
export type GetClinicianProfileQueryError = ErrorType<unknown>


/**
 * @summary Get the signed-in clinician's profile (backed by their default provider, auto-created on first access)
 */

export function useGetClinicianProfile<TData = Awaited<ReturnType<typeof getClinicianProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClinicianProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClinicianProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateClinicianProfileUrl = () => {




  return `/api/me/profile`
}

/**
 * @summary Update the signed-in clinician's profile
 */
export const updateClinicianProfile = async (clinicianProfileUpdate: ClinicianProfileUpdate, options?: RequestInit): Promise<ClinicianProfile> => {

  return customFetch<ClinicianProfile>(getUpdateClinicianProfileUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      clinicianProfileUpdate,)
  }
);}




export const getUpdateClinicianProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClinicianProfile>>, TError,{data: BodyType<ClinicianProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateClinicianProfile>>, TError,{data: BodyType<ClinicianProfileUpdate>}, TContext> => {

const mutationKey = ['updateClinicianProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateClinicianProfile>>, {data: BodyType<ClinicianProfileUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateClinicianProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateClinicianProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateClinicianProfile>>>
    export type UpdateClinicianProfileMutationBody = BodyType<ClinicianProfileUpdate>
    export type UpdateClinicianProfileMutationError = ErrorType<unknown>

    /**
 * @summary Update the signed-in clinician's profile
 */
export const useUpdateClinicianProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClinicianProfile>>, TError,{data: BodyType<ClinicianProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateClinicianProfile>>,
        TError,
        {data: BodyType<ClinicianProfileUpdate>},
        TContext
      > => {
      return useMutation(getUpdateClinicianProfileMutationOptions(options));
    }

export const getGetSecuritySettingsUrl = () => {




  return `/api/security-settings`
}

/**
 * @summary Get the user's security preferences
 */
export const getSecuritySettings = async ( options?: RequestInit): Promise<SecuritySettings> => {

  return customFetch<SecuritySettings>(getGetSecuritySettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSecuritySettingsQueryKey = () => {
    return [
    `/api/security-settings`
    ] as const;
    }


export const getGetSecuritySettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSecuritySettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSecuritySettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSecuritySettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSecuritySettings>>> = ({ signal }) => getSecuritySettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSecuritySettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSecuritySettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSecuritySettings>>>
export type GetSecuritySettingsQueryError = ErrorType<unknown>


/**
 * @summary Get the user's security preferences
 */

export function useGetSecuritySettings<TData = Awaited<ReturnType<typeof getSecuritySettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSecuritySettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSecuritySettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateSecuritySettingsUrl = () => {




  return `/api/security-settings`
}

/**
 * @summary Update the user's security preferences
 */
export const updateSecuritySettings = async (securitySettingsUpdate: SecuritySettingsUpdate, options?: RequestInit): Promise<SecuritySettings> => {

  return customFetch<SecuritySettings>(getUpdateSecuritySettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      securitySettingsUpdate,)
  }
);}




export const getUpdateSecuritySettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSecuritySettings>>, TError,{data: BodyType<SecuritySettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSecuritySettings>>, TError,{data: BodyType<SecuritySettingsUpdate>}, TContext> => {

const mutationKey = ['updateSecuritySettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSecuritySettings>>, {data: BodyType<SecuritySettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateSecuritySettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSecuritySettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSecuritySettings>>>
    export type UpdateSecuritySettingsMutationBody = BodyType<SecuritySettingsUpdate>
    export type UpdateSecuritySettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update the user's security preferences
 */
export const useUpdateSecuritySettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSecuritySettings>>, TError,{data: BodyType<SecuritySettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSecuritySettings>>,
        TError,
        {data: BodyType<SecuritySettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSecuritySettingsMutationOptions(options));
    }

export const getListAuditLogsUrl = (params?: ListAuditLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/audit?${stringifiedParams}` : `/api/audit`
}

/**
 * @summary List recent audit events
 */
export const listAuditLogs = async (params?: ListAuditLogsParams, options?: RequestInit): Promise<AuditLog[]> => {

  return customFetch<AuditLog[]>(getListAuditLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditLogsQueryKey = (params?: ListAuditLogsParams,) => {
    return [
    `/api/audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>(params?: ListAuditLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLogs>>> = ({ signal }) => listAuditLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLogs>>>
export type ListAuditLogsQueryError = ErrorType<unknown>


/**
 * @summary List recent audit events
 */

export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>(
 params?: ListAuditLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAuditLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRecordAuditEventUrl = () => {




  return `/api/audit/events`
}

/**
 * @summary Record a client-reported audit event
 */
export const recordAuditEvent = async (auditEventInput: AuditEventInput, options?: RequestInit): Promise<AuditEventResult> => {

  return customFetch<AuditEventResult>(getRecordAuditEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      auditEventInput,)
  }
);}




export const getRecordAuditEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAuditEvent>>, TError,{data: BodyType<AuditEventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordAuditEvent>>, TError,{data: BodyType<AuditEventInput>}, TContext> => {

const mutationKey = ['recordAuditEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordAuditEvent>>, {data: BodyType<AuditEventInput>}> = (props) => {
          const {data} = props ?? {};

          return  recordAuditEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordAuditEventMutationResult = NonNullable<Awaited<ReturnType<typeof recordAuditEvent>>>
    export type RecordAuditEventMutationBody = BodyType<AuditEventInput>
    export type RecordAuditEventMutationError = ErrorType<unknown>

    /**
 * @summary Record a client-reported audit event
 */
export const useRecordAuditEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAuditEvent>>, TError,{data: BodyType<AuditEventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordAuditEvent>>,
        TError,
        {data: BodyType<AuditEventInput>},
        TContext
      > => {
      return useMutation(getRecordAuditEventMutationOptions(options));
    }

export const getGetRetentionSettingsUrl = () => {




  return `/api/retention`
}

/**
 * @summary Get data-retention settings (admin only)
 */
export const getRetentionSettings = async ( options?: RequestInit): Promise<RetentionSettings> => {

  return customFetch<RetentionSettings>(getGetRetentionSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRetentionSettingsQueryKey = () => {
    return [
    `/api/retention`
    ] as const;
    }


export const getGetRetentionSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getRetentionSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRetentionSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRetentionSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRetentionSettings>>> = ({ signal }) => getRetentionSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRetentionSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRetentionSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getRetentionSettings>>>
export type GetRetentionSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get data-retention settings (admin only)
 */

export function useGetRetentionSettings<TData = Awaited<ReturnType<typeof getRetentionSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRetentionSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRetentionSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateRetentionSettingsUrl = () => {




  return `/api/retention`
}

/**
 * @summary Update data-retention settings (admin only)
 */
export const updateRetentionSettings = async (retentionSettingsUpdate: RetentionSettingsUpdate, options?: RequestInit): Promise<RetentionSettings> => {

  return customFetch<RetentionSettings>(getUpdateRetentionSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      retentionSettingsUpdate,)
  }
);}




export const getUpdateRetentionSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRetentionSettings>>, TError,{data: BodyType<RetentionSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRetentionSettings>>, TError,{data: BodyType<RetentionSettingsUpdate>}, TContext> => {

const mutationKey = ['updateRetentionSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRetentionSettings>>, {data: BodyType<RetentionSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateRetentionSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRetentionSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateRetentionSettings>>>
    export type UpdateRetentionSettingsMutationBody = BodyType<RetentionSettingsUpdate>
    export type UpdateRetentionSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update data-retention settings (admin only)
 */
export const useUpdateRetentionSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRetentionSettings>>, TError,{data: BodyType<RetentionSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRetentionSettings>>,
        TError,
        {data: BodyType<RetentionSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateRetentionSettingsMutationOptions(options));
    }

export const getExportPatientDataUrl = () => {




  return `/api/export/patients`
}

/**
 * @summary Export all of the user's patient and note data as JSON
 */
export const exportPatientData = async ( options?: RequestInit): Promise<PatientExport> => {

  return customFetch<PatientExport>(getExportPatientDataUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportPatientDataQueryKey = () => {
    return [
    `/api/export/patients`
    ] as const;
    }


export const getExportPatientDataQueryOptions = <TData = Awaited<ReturnType<typeof exportPatientData>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportPatientData>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportPatientDataQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportPatientData>>> = ({ signal }) => exportPatientData({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportPatientData>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportPatientDataQueryResult = NonNullable<Awaited<ReturnType<typeof exportPatientData>>>
export type ExportPatientDataQueryError = ErrorType<unknown>


/**
 * @summary Export all of the user's patient and note data as JSON
 */

export function useExportPatientData<TData = Awaited<ReturnType<typeof exportPatientData>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportPatientData>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportPatientDataQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDeleteAccountUrl = (params: DeleteAccountParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/account?${stringifiedParams}` : `/api/account`
}

/**
 * @summary Permanently delete the caller's account and all associated personal data (right to erasure)
 */
export const deleteAccount = async (params: DeleteAccountParams, options?: RequestInit): Promise<AccountDeletion> => {

  return customFetch<AccountDeletion>(getDeleteAccountUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{params: DeleteAccountParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{params: DeleteAccountParams}, TContext> => {

const mutationKey = ['deleteAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccount>>, {params: DeleteAccountParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteAccount(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccount>>>

    export type DeleteAccountMutationError = ErrorType<unknown>

    /**
 * @summary Permanently delete the caller's account and all associated personal data (right to erasure)
 */
export const useDeleteAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{params: DeleteAccountParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccount>>,
        TError,
        {params: DeleteAccountParams},
        TContext
      > => {
      return useMutation(getDeleteAccountMutationOptions(options));
    }

export const getListMembersUrl = () => {




  return `/api/admin/members`
}

/**
 * @summary List clinic members and their roles (admin only)
 */
export const listMembers = async ( options?: RequestInit): Promise<Member[]> => {

  return customFetch<Member[]>(getListMembersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMembersQueryKey = () => {
    return [
    `/api/admin/members`
    ] as const;
    }


export const getListMembersQueryOptions = <TData = Awaited<ReturnType<typeof listMembers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMembersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMembers>>> = ({ signal }) => listMembers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listMembers>>>
export type ListMembersQueryError = ErrorType<unknown>


/**
 * @summary List clinic members and their roles (admin only)
 */

export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMembersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateMemberRoleUrl = (userId: string,) => {




  return `/api/admin/members/${userId}`
}

/**
 * @summary Set a member's role (admin only)
 */
export const updateMemberRole = async (userId: string,
    memberRoleUpdate: MemberRoleUpdate, options?: RequestInit): Promise<MemberRole> => {

  return customFetch<MemberRole>(getUpdateMemberRoleUrl(userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      memberRoleUpdate,)
  }
);}




export const getUpdateMemberRoleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemberRole>>, TError,{userId: string;data: BodyType<MemberRoleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMemberRole>>, TError,{userId: string;data: BodyType<MemberRoleUpdate>}, TContext> => {

const mutationKey = ['updateMemberRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMemberRole>>, {userId: string;data: BodyType<MemberRoleUpdate>}> = (props) => {
          const {userId,data} = props ?? {};

          return  updateMemberRole(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMemberRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateMemberRole>>>
    export type UpdateMemberRoleMutationBody = BodyType<MemberRoleUpdate>
    export type UpdateMemberRoleMutationError = ErrorType<unknown>

    /**
 * @summary Set a member's role (admin only)
 */
export const useUpdateMemberRole = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemberRole>>, TError,{userId: string;data: BodyType<MemberRoleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMemberRole>>,
        TError,
        {userId: string;data: BodyType<MemberRoleUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMemberRoleMutationOptions(options));
    }

export const getListOpenaiConversationsUrl = () => {




  return `/api/openai/conversations`
}

/**
 * @summary List all conversations
 */
export const listOpenaiConversations = async ( options?: RequestInit): Promise<OpenaiConversation[]> => {

  return customFetch<OpenaiConversation[]>(getListOpenaiConversationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpenaiConversationsQueryKey = () => {
    return [
    `/api/openai/conversations`
    ] as const;
    }


export const getListOpenaiConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listOpenaiConversations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpenaiConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpenaiConversationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpenaiConversations>>> = ({ signal }) => listOpenaiConversations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpenaiConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpenaiConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listOpenaiConversations>>>
export type ListOpenaiConversationsQueryError = ErrorType<unknown>


/**
 * @summary List all conversations
 */

export function useListOpenaiConversations<TData = Awaited<ReturnType<typeof listOpenaiConversations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpenaiConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpenaiConversationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOpenaiConversationUrl = () => {




  return `/api/openai/conversations`
}

/**
 * @summary Create a new conversation
 */
export const createOpenaiConversation = async (openaiConversationInput: OpenaiConversationInput, options?: RequestInit): Promise<OpenaiConversation> => {

  return customFetch<OpenaiConversation>(getCreateOpenaiConversationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      openaiConversationInput,)
  }
);}




export const getCreateOpenaiConversationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpenaiConversation>>, TError,{data: BodyType<OpenaiConversationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOpenaiConversation>>, TError,{data: BodyType<OpenaiConversationInput>}, TContext> => {

const mutationKey = ['createOpenaiConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOpenaiConversation>>, {data: BodyType<OpenaiConversationInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOpenaiConversation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOpenaiConversationMutationResult = NonNullable<Awaited<ReturnType<typeof createOpenaiConversation>>>
    export type CreateOpenaiConversationMutationBody = BodyType<OpenaiConversationInput>
    export type CreateOpenaiConversationMutationError = ErrorType<unknown>

    /**
 * @summary Create a new conversation
 */
export const useCreateOpenaiConversation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpenaiConversation>>, TError,{data: BodyType<OpenaiConversationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOpenaiConversation>>,
        TError,
        {data: BodyType<OpenaiConversationInput>},
        TContext
      > => {
      return useMutation(getCreateOpenaiConversationMutationOptions(options));
    }

export const getGetOpenaiConversationUrl = (id: number,) => {




  return `/api/openai/conversations/${id}`
}

/**
 * @summary Get conversation with messages
 */
export const getOpenaiConversation = async (id: number, options?: RequestInit): Promise<OpenaiConversationWithMessages> => {

  return customFetch<OpenaiConversationWithMessages>(getGetOpenaiConversationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOpenaiConversationQueryKey = (id: number,) => {
    return [
    `/api/openai/conversations/${id}`
    ] as const;
    }


export const getGetOpenaiConversationQueryOptions = <TData = Awaited<ReturnType<typeof getOpenaiConversation>>, TError = ErrorType<OpenaiError>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpenaiConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpenaiConversationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpenaiConversation>>> = ({ signal }) => getOpenaiConversation(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpenaiConversation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOpenaiConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getOpenaiConversation>>>
export type GetOpenaiConversationQueryError = ErrorType<OpenaiError>


/**
 * @summary Get conversation with messages
 */

export function useGetOpenaiConversation<TData = Awaited<ReturnType<typeof getOpenaiConversation>>, TError = ErrorType<OpenaiError>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpenaiConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOpenaiConversationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDeleteOpenaiConversationUrl = (id: number,) => {




  return `/api/openai/conversations/${id}`
}

/**
 * @summary Delete a conversation
 */
export const deleteOpenaiConversation = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteOpenaiConversationUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteOpenaiConversationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOpenaiConversation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOpenaiConversation>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteOpenaiConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOpenaiConversation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteOpenaiConversation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOpenaiConversationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOpenaiConversation>>>

    export type DeleteOpenaiConversationMutationError = ErrorType<unknown>

    /**
 * @summary Delete a conversation
 */
export const useDeleteOpenaiConversation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOpenaiConversation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteOpenaiConversation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteOpenaiConversationMutationOptions(options));
    }

export const getListOpenaiMessagesUrl = (id: number,) => {




  return `/api/openai/conversations/${id}/messages`
}

/**
 * @summary List messages in a conversation
 */
export const listOpenaiMessages = async (id: number, options?: RequestInit): Promise<OpenaiMessage[]> => {

  return customFetch<OpenaiMessage[]>(getListOpenaiMessagesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpenaiMessagesQueryKey = (id: number,) => {
    return [
    `/api/openai/conversations/${id}/messages`
    ] as const;
    }


export const getListOpenaiMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listOpenaiMessages>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpenaiMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpenaiMessagesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpenaiMessages>>> = ({ signal }) => listOpenaiMessages(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpenaiMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpenaiMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listOpenaiMessages>>>
export type ListOpenaiMessagesQueryError = ErrorType<unknown>


/**
 * @summary List messages in a conversation
 */

export function useListOpenaiMessages<TData = Awaited<ReturnType<typeof listOpenaiMessages>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpenaiMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpenaiMessagesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSendOpenaiMessageUrl = (id: number,) => {




  return `/api/openai/conversations/${id}/messages`
}

/**
 * @summary Send a text message and receive a streaming text response
 */
export const sendOpenaiMessage = async (id: number,
    openaiMessageInput: OpenaiMessageInput, options?: RequestInit): Promise<unknown> => {

  return customFetch<unknown>(getSendOpenaiMessageUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      openaiMessageInput,)
  }
);}




export const getSendOpenaiMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOpenaiMessage>>, TError,{id: number;data: BodyType<OpenaiMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendOpenaiMessage>>, TError,{id: number;data: BodyType<OpenaiMessageInput>}, TContext> => {

const mutationKey = ['sendOpenaiMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendOpenaiMessage>>, {id: number;data: BodyType<OpenaiMessageInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendOpenaiMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendOpenaiMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendOpenaiMessage>>>
    export type SendOpenaiMessageMutationBody = BodyType<OpenaiMessageInput>
    export type SendOpenaiMessageMutationError = ErrorType<unknown>

    /**
 * @summary Send a text message and receive a streaming text response
 */
export const useSendOpenaiMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOpenaiMessage>>, TError,{id: number;data: BodyType<OpenaiMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendOpenaiMessage>>,
        TError,
        {id: number;data: BodyType<OpenaiMessageInput>},
        TContext
      > => {
      return useMutation(getSendOpenaiMessageMutationOptions(options));
    }

export const getGenerateOpenaiImageUrl = () => {




  return `/api/openai/generate-image`
}

/**
 * @summary Generate an image from a text prompt
 */
export const generateOpenaiImage = async (openaiImageInput: OpenaiImageInput, options?: RequestInit): Promise<OpenaiImageOutput> => {

  return customFetch<OpenaiImageOutput>(getGenerateOpenaiImageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      openaiImageInput,)
  }
);}




export const getGenerateOpenaiImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateOpenaiImage>>, TError,{data: BodyType<OpenaiImageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateOpenaiImage>>, TError,{data: BodyType<OpenaiImageInput>}, TContext> => {

const mutationKey = ['generateOpenaiImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateOpenaiImage>>, {data: BodyType<OpenaiImageInput>}> = (props) => {
          const {data} = props ?? {};

          return  generateOpenaiImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateOpenaiImageMutationResult = NonNullable<Awaited<ReturnType<typeof generateOpenaiImage>>>
    export type GenerateOpenaiImageMutationBody = BodyType<OpenaiImageInput>
    export type GenerateOpenaiImageMutationError = ErrorType<unknown>

    /**
 * @summary Generate an image from a text prompt
 */
export const useGenerateOpenaiImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateOpenaiImage>>, TError,{data: BodyType<OpenaiImageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateOpenaiImage>>,
        TError,
        {data: BodyType<OpenaiImageInput>},
        TContext
      > => {
      return useMutation(getGenerateOpenaiImageMutationOptions(options));
    }

export const getCreateCheckoutSessionUrl = () => {




  return `/api/billing/checkout`
}

/**
 * @summary Create a Stripe Checkout Session for the Professional subscription
 */
export const createCheckoutSession = async (checkoutInput?: CheckoutInput, options?: RequestInit): Promise<CheckoutUrl> => {

  return customFetch<CheckoutUrl>(getCreateCheckoutSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      checkoutInput,)
  }
);}




export const getCreateCheckoutSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCheckoutSession>>, TError,{data?: BodyType<CheckoutInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCheckoutSession>>, TError,{data?: BodyType<CheckoutInput>}, TContext> => {

const mutationKey = ['createCheckoutSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCheckoutSession>>, {data?: BodyType<CheckoutInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCheckoutSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCheckoutSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createCheckoutSession>>>
    export type CreateCheckoutSessionMutationBody = BodyType<CheckoutInput> | undefined
    export type CreateCheckoutSessionMutationError = ErrorType<unknown>

    /**
 * @summary Create a Stripe Checkout Session for the Professional subscription
 */
export const useCreateCheckoutSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCheckoutSession>>, TError,{data?: BodyType<CheckoutInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCheckoutSession>>,
        TError,
        {data?: BodyType<CheckoutInput>},
        TContext
      > => {
      return useMutation(getCreateCheckoutSessionMutationOptions(options));
    }

export const getConfirmCheckoutUrl = () => {




  return `/api/billing/checkout/confirm`
}

/**
 * @summary Sync a completed Checkout Session immediately (used on success page)
 */
export const confirmCheckout = async (checkoutConfirmInput: CheckoutConfirmInput, options?: RequestInit): Promise<SubscriptionStatus> => {

  return customFetch<SubscriptionStatus>(getConfirmCheckoutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      checkoutConfirmInput,)
  }
);}




export const getConfirmCheckoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCheckout>>, TError,{data: BodyType<CheckoutConfirmInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmCheckout>>, TError,{data: BodyType<CheckoutConfirmInput>}, TContext> => {

const mutationKey = ['confirmCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmCheckout>>, {data: BodyType<CheckoutConfirmInput>}> = (props) => {
          const {data} = props ?? {};

          return  confirmCheckout(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof confirmCheckout>>>
    export type ConfirmCheckoutMutationBody = BodyType<CheckoutConfirmInput>
    export type ConfirmCheckoutMutationError = ErrorType<unknown>

    /**
 * @summary Sync a completed Checkout Session immediately (used on success page)
 */
export const useConfirmCheckout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCheckout>>, TError,{data: BodyType<CheckoutConfirmInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmCheckout>>,
        TError,
        {data: BodyType<CheckoutConfirmInput>},
        TContext
      > => {
      return useMutation(getConfirmCheckoutMutationOptions(options));
    }

export const getGetSubscriptionUrl = () => {




  return `/api/billing/subscription`
}

/**
 * @summary Get the caller's current subscription status
 */
export const getSubscription = async ( options?: RequestInit): Promise<SubscriptionStatus> => {

  return customFetch<SubscriptionStatus>(getGetSubscriptionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSubscriptionQueryKey = () => {
    return [
    `/api/billing/subscription`
    ] as const;
    }


export const getGetSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getSubscription>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscription>>> = ({ signal }) => getSubscription({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscription>>>
export type GetSubscriptionQueryError = ErrorType<unknown>


/**
 * @summary Get the caller's current subscription status
 */

export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSubscriptionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBillingPortalSessionUrl = () => {




  return `/api/billing/portal`
}

/**
 * @summary Create a Stripe Billing Portal session for the caller
 */
export const createBillingPortalSession = async (checkoutInput?: CheckoutInput, options?: RequestInit): Promise<CheckoutUrl> => {

  return customFetch<CheckoutUrl>(getCreateBillingPortalSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      checkoutInput,)
  }
);}




export const getCreateBillingPortalSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingPortalSession>>, TError,{data?: BodyType<CheckoutInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBillingPortalSession>>, TError,{data?: BodyType<CheckoutInput>}, TContext> => {

const mutationKey = ['createBillingPortalSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBillingPortalSession>>, {data?: BodyType<CheckoutInput>}> = (props) => {
          const {data} = props ?? {};

          return  createBillingPortalSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBillingPortalSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createBillingPortalSession>>>
    export type CreateBillingPortalSessionMutationBody = BodyType<CheckoutInput> | undefined
    export type CreateBillingPortalSessionMutationError = ErrorType<unknown>

    /**
 * @summary Create a Stripe Billing Portal session for the caller
 */
export const useCreateBillingPortalSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingPortalSession>>, TError,{data?: BodyType<CheckoutInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBillingPortalSession>>,
        TError,
        {data?: BodyType<CheckoutInput>},
        TContext
      > => {
      return useMutation(getCreateBillingPortalSessionMutationOptions(options));
    }

export const getListIntakeTemplatesUrl = () => {




  return `/api/intake-templates`
}

/**
 * @summary List intake templates available to the authenticated clinician
 */
export const listIntakeTemplates = async ( options?: RequestInit): Promise<IntakeTemplate[]> => {

  return customFetch<IntakeTemplate[]>(getListIntakeTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListIntakeTemplatesQueryKey = () => {
    return [
    `/api/intake-templates`
    ] as const;
    }


export const getListIntakeTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listIntakeTemplates>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listIntakeTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIntakeTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIntakeTemplates>>> = ({ signal }) => listIntakeTemplates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIntakeTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListIntakeTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listIntakeTemplates>>>
export type ListIntakeTemplatesQueryError = ErrorType<unknown>


/**
 * @summary List intake templates available to the authenticated clinician
 */

export function useListIntakeTemplates<TData = Awaited<ReturnType<typeof listIntakeTemplates>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listIntakeTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListIntakeTemplatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateIntakeTemplateUrl = () => {




  return `/api/intake-templates`
}

/**
 * @summary Create a clinic intake template (admin only)
 */
export const createIntakeTemplate = async (intakeTemplateInput: IntakeTemplateInput, options?: RequestInit): Promise<IntakeTemplate> => {

  return customFetch<IntakeTemplate>(getCreateIntakeTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      intakeTemplateInput,)
  }
);}




export const getCreateIntakeTemplateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIntakeTemplate>>, TError,{data: BodyType<IntakeTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createIntakeTemplate>>, TError,{data: BodyType<IntakeTemplateInput>}, TContext> => {

const mutationKey = ['createIntakeTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createIntakeTemplate>>, {data: BodyType<IntakeTemplateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createIntakeTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateIntakeTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createIntakeTemplate>>>
    export type CreateIntakeTemplateMutationBody = BodyType<IntakeTemplateInput>
    export type CreateIntakeTemplateMutationError = ErrorType<ApiError>

    /**
 * @summary Create a clinic intake template (admin only)
 */
export const useCreateIntakeTemplate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIntakeTemplate>>, TError,{data: BodyType<IntakeTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createIntakeTemplate>>,
        TError,
        {data: BodyType<IntakeTemplateInput>},
        TContext
      > => {
      return useMutation(getCreateIntakeTemplateMutationOptions(options));
    }

export const getGetIntakeTemplateUrl = (id: number,) => {




  return `/api/intake-templates/${id}`
}

/**
 * @summary Get a single intake template visible to the caller
 */
export const getIntakeTemplate = async (id: number, options?: RequestInit): Promise<IntakeTemplate> => {

  return customFetch<IntakeTemplate>(getGetIntakeTemplateUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntakeTemplateQueryKey = (id: number,) => {
    return [
    `/api/intake-templates/${id}`
    ] as const;
    }


export const getGetIntakeTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getIntakeTemplate>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntakeTemplate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntakeTemplateQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntakeTemplate>>> = ({ signal }) => getIntakeTemplate(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntakeTemplate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntakeTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getIntakeTemplate>>>
export type GetIntakeTemplateQueryError = ErrorType<ApiError>


/**
 * @summary Get a single intake template visible to the caller
 */

export function useGetIntakeTemplate<TData = Awaited<ReturnType<typeof getIntakeTemplate>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntakeTemplate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntakeTemplateQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateIntakeTemplateUrl = (id: number,) => {




  return `/api/intake-templates/${id}`
}

/**
 * @summary Update a clinic intake template (admin only)
 */
export const updateIntakeTemplate = async (id: number,
    intakeTemplateInput: IntakeTemplateInput, options?: RequestInit): Promise<IntakeTemplate> => {

  return customFetch<IntakeTemplate>(getUpdateIntakeTemplateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      intakeTemplateInput,)
  }
);}




export const getUpdateIntakeTemplateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIntakeTemplate>>, TError,{id: number;data: BodyType<IntakeTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateIntakeTemplate>>, TError,{id: number;data: BodyType<IntakeTemplateInput>}, TContext> => {

const mutationKey = ['updateIntakeTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateIntakeTemplate>>, {id: number;data: BodyType<IntakeTemplateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateIntakeTemplate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateIntakeTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateIntakeTemplate>>>
    export type UpdateIntakeTemplateMutationBody = BodyType<IntakeTemplateInput>
    export type UpdateIntakeTemplateMutationError = ErrorType<ApiError>

    /**
 * @summary Update a clinic intake template (admin only)
 */
export const useUpdateIntakeTemplate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIntakeTemplate>>, TError,{id: number;data: BodyType<IntakeTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateIntakeTemplate>>,
        TError,
        {id: number;data: BodyType<IntakeTemplateInput>},
        TContext
      > => {
      return useMutation(getUpdateIntakeTemplateMutationOptions(options));
    }

export const getDeleteIntakeTemplateUrl = (id: number,) => {




  return `/api/intake-templates/${id}`
}

/**
 * @summary Retire a clinic intake template (admin only)
 */
export const deleteIntakeTemplate = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteIntakeTemplateUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteIntakeTemplateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntakeTemplate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntakeTemplate>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteIntakeTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntakeTemplate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteIntakeTemplate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntakeTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntakeTemplate>>>

    export type DeleteIntakeTemplateMutationError = ErrorType<ApiError>

    /**
 * @summary Retire a clinic intake template (admin only)
 */
export const useDeleteIntakeTemplate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntakeTemplate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntakeTemplate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteIntakeTemplateMutationOptions(options));
    }

export const getDuplicateIntakeTemplateUrl = (id: number,) => {




  return `/api/intake-templates/${id}/duplicate`
}

/**
 * @summary Duplicate an intake template into a new editable clinic template (admin only)
 */
export const duplicateIntakeTemplate = async (id: number,
    intakeTemplateDuplicateInput?: IntakeTemplateDuplicateInput, options?: RequestInit): Promise<IntakeTemplate> => {

  return customFetch<IntakeTemplate>(getDuplicateIntakeTemplateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      intakeTemplateDuplicateInput,)
  }
);}




export const getDuplicateIntakeTemplateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateIntakeTemplate>>, TError,{id: number;data?: BodyType<IntakeTemplateDuplicateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateIntakeTemplate>>, TError,{id: number;data?: BodyType<IntakeTemplateDuplicateInput>}, TContext> => {

const mutationKey = ['duplicateIntakeTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateIntakeTemplate>>, {id: number;data?: BodyType<IntakeTemplateDuplicateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  duplicateIntakeTemplate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateIntakeTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateIntakeTemplate>>>
    export type DuplicateIntakeTemplateMutationBody = BodyType<IntakeTemplateDuplicateInput> | undefined
    export type DuplicateIntakeTemplateMutationError = ErrorType<ApiError>

    /**
 * @summary Duplicate an intake template into a new editable clinic template (admin only)
 */
export const useDuplicateIntakeTemplate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateIntakeTemplate>>, TError,{id: number;data?: BodyType<IntakeTemplateDuplicateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof duplicateIntakeTemplate>>,
        TError,
        {id: number;data?: BodyType<IntakeTemplateDuplicateInput>},
        TContext
      > => {
      return useMutation(getDuplicateIntakeTemplateMutationOptions(options));
    }

export const getListIntakesUrl = (params?: ListIntakesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/intakes?${stringifiedParams}` : `/api/intakes`
}

/**
 * @summary List patient intakes for the authenticated clinician
 */
export const listIntakes = async (params?: ListIntakesParams, options?: RequestInit): Promise<Intake[]> => {

  return customFetch<Intake[]>(getListIntakesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListIntakesQueryKey = (params?: ListIntakesParams,) => {
    return [
    `/api/intakes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListIntakesQueryOptions = <TData = Awaited<ReturnType<typeof listIntakes>>, TError = ErrorType<unknown>>(params?: ListIntakesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listIntakes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIntakesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIntakes>>> = ({ signal }) => listIntakes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIntakes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListIntakesQueryResult = NonNullable<Awaited<ReturnType<typeof listIntakes>>>
export type ListIntakesQueryError = ErrorType<unknown>


/**
 * @summary List patient intakes for the authenticated clinician
 */

export function useListIntakes<TData = Awaited<ReturnType<typeof listIntakes>>, TError = ErrorType<unknown>>(
 params?: ListIntakesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listIntakes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListIntakesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateIntakeUrl = () => {




  return `/api/intakes`
}

/**
 * @summary Create a patient intake and generate a secure shareable link
 */
export const createIntake = async (intakeInput: IntakeInput, options?: RequestInit): Promise<Intake> => {

  return customFetch<Intake>(getCreateIntakeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      intakeInput,)
  }
);}




export const getCreateIntakeMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIntake>>, TError,{data: BodyType<IntakeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createIntake>>, TError,{data: BodyType<IntakeInput>}, TContext> => {

const mutationKey = ['createIntake'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createIntake>>, {data: BodyType<IntakeInput>}> = (props) => {
          const {data} = props ?? {};

          return  createIntake(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateIntakeMutationResult = NonNullable<Awaited<ReturnType<typeof createIntake>>>
    export type CreateIntakeMutationBody = BodyType<IntakeInput>
    export type CreateIntakeMutationError = ErrorType<ApiError>

    /**
 * @summary Create a patient intake and generate a secure shareable link
 */
export const useCreateIntake = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIntake>>, TError,{data: BodyType<IntakeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createIntake>>,
        TError,
        {data: BodyType<IntakeInput>},
        TContext
      > => {
      return useMutation(getCreateIntakeMutationOptions(options));
    }

export const getGetIntakePrefillUrl = (params: GetIntakePrefillParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/intakes/prefill?${stringifiedParams}` : `/api/intakes/prefill`
}

/**
 * @summary SOAP pre-population data derived from a patient's latest completed intake
 */
export const getIntakePrefill = async (params: GetIntakePrefillParams, options?: RequestInit): Promise<IntakePrefillResult> => {

  return customFetch<IntakePrefillResult>(getGetIntakePrefillUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntakePrefillQueryKey = (params?: GetIntakePrefillParams,) => {
    return [
    `/api/intakes/prefill`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetIntakePrefillQueryOptions = <TData = Awaited<ReturnType<typeof getIntakePrefill>>, TError = ErrorType<ApiError>>(params: GetIntakePrefillParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntakePrefill>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntakePrefillQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntakePrefill>>> = ({ signal }) => getIntakePrefill(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntakePrefill>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntakePrefillQueryResult = NonNullable<Awaited<ReturnType<typeof getIntakePrefill>>>
export type GetIntakePrefillQueryError = ErrorType<ApiError>


/**
 * @summary SOAP pre-population data derived from a patient's latest completed intake
 */

export function useGetIntakePrefill<TData = Awaited<ReturnType<typeof getIntakePrefill>>, TError = ErrorType<ApiError>>(
 params: GetIntakePrefillParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntakePrefill>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntakePrefillQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetIntakeUrl = (id: number,) => {




  return `/api/intakes/${id}`
}

/**
 * @summary Get a patient intake by ID, including answers and template
 */
export const getIntake = async (id: number, options?: RequestInit): Promise<IntakeDetail> => {

  return customFetch<IntakeDetail>(getGetIntakeUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntakeQueryKey = (id: number,) => {
    return [
    `/api/intakes/${id}`
    ] as const;
    }


export const getGetIntakeQueryOptions = <TData = Awaited<ReturnType<typeof getIntake>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntake>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntakeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntake>>> = ({ signal }) => getIntake(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntake>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntakeQueryResult = NonNullable<Awaited<ReturnType<typeof getIntake>>>
export type GetIntakeQueryError = ErrorType<ApiError>


/**
 * @summary Get a patient intake by ID, including answers and template
 */

export function useGetIntake<TData = Awaited<ReturnType<typeof getIntake>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntake>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntakeQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDeleteIntakeUrl = (id: number,) => {




  return `/api/intakes/${id}`
}

/**
 * @summary Delete a patient intake and its derived outcome-measure history
 */
export const deleteIntake = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteIntakeUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteIntakeMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntake>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntake>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteIntake'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntake>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteIntake(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntakeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntake>>>

    export type DeleteIntakeMutationError = ErrorType<ApiError>

    /**
 * @summary Delete a patient intake and its derived outcome-measure history
 */
export const useDeleteIntake = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntake>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntake>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteIntakeMutationOptions(options));
    }

export const getGetIntakeSummaryUrl = (id: number,) => {




  return `/api/intakes/${id}/summary`
}

/**
 * @summary AI-generated pre-visit summary for a completed intake (generated on demand, then cached)
 */
export const getIntakeSummary = async (id: number, options?: RequestInit): Promise<PreVisitSummary> => {

  return customFetch<PreVisitSummary>(getGetIntakeSummaryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntakeSummaryQueryKey = (id: number,) => {
    return [
    `/api/intakes/${id}/summary`
    ] as const;
    }


export const getGetIntakeSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getIntakeSummary>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntakeSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntakeSummaryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntakeSummary>>> = ({ signal }) => getIntakeSummary(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntakeSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntakeSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getIntakeSummary>>>
export type GetIntakeSummaryQueryError = ErrorType<ApiError>


/**
 * @summary AI-generated pre-visit summary for a completed intake (generated on demand, then cached)
 */

export function useGetIntakeSummary<TData = Awaited<ReturnType<typeof getIntakeSummary>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntakeSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntakeSummaryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetPublicIntakeUrl = (token: string,) => {




  return `/api/public/intakes/${token}`
}

/**
 * @summary Fetch an intake and its template by secure token (no authentication)
 */
export const getPublicIntake = async (token: string, options?: RequestInit): Promise<PublicIntake> => {

  return customFetch<PublicIntake>(getGetPublicIntakeUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicIntakeQueryKey = (token: string,) => {
    return [
    `/api/public/intakes/${token}`
    ] as const;
    }


export const getGetPublicIntakeQueryOptions = <TData = Awaited<ReturnType<typeof getPublicIntake>>, TError = ErrorType<ApiError>>(token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicIntake>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicIntakeQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicIntake>>> = ({ signal }) => getPublicIntake(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicIntake>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicIntakeQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicIntake>>>
export type GetPublicIntakeQueryError = ErrorType<ApiError>


/**
 * @summary Fetch an intake and its template by secure token (no authentication)
 */

export function useGetPublicIntake<TData = Awaited<ReturnType<typeof getPublicIntake>>, TError = ErrorType<ApiError>>(
 token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicIntake>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicIntakeQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSavePublicIntakeUrl = (token: string,) => {




  return `/api/public/intakes/${token}`
}

/**
 * @summary Autosave intake answers by secure token (no authentication)
 */
export const savePublicIntake = async (token: string,
    publicIntakeSaveInput: PublicIntakeSaveInput, options?: RequestInit): Promise<PublicIntakeSaveResult> => {

  return customFetch<PublicIntakeSaveResult>(getSavePublicIntakeUrl(token),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      publicIntakeSaveInput,)
  }
);}




export const getSavePublicIntakeMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePublicIntake>>, TError,{token: string;data: BodyType<PublicIntakeSaveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof savePublicIntake>>, TError,{token: string;data: BodyType<PublicIntakeSaveInput>}, TContext> => {

const mutationKey = ['savePublicIntake'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof savePublicIntake>>, {token: string;data: BodyType<PublicIntakeSaveInput>}> = (props) => {
          const {token,data} = props ?? {};

          return  savePublicIntake(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SavePublicIntakeMutationResult = NonNullable<Awaited<ReturnType<typeof savePublicIntake>>>
    export type SavePublicIntakeMutationBody = BodyType<PublicIntakeSaveInput>
    export type SavePublicIntakeMutationError = ErrorType<ApiError>

    /**
 * @summary Autosave intake answers by secure token (no authentication)
 */
export const useSavePublicIntake = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePublicIntake>>, TError,{token: string;data: BodyType<PublicIntakeSaveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof savePublicIntake>>,
        TError,
        {token: string;data: BodyType<PublicIntakeSaveInput>},
        TContext
      > => {
      return useMutation(getSavePublicIntakeMutationOptions(options));
    }

export const getSetPublicIntakeModeUrl = (token: string,) => {




  return `/api/public/intakes/${token}/mode`
}

/**
 * @summary Choose how to complete the intake (form, chat, or voice) by secure token (no authentication)
 */
export const setPublicIntakeMode = async (token: string,
    publicIntakeModeInput: PublicIntakeModeInput, options?: RequestInit): Promise<PublicIntakeModeResult> => {

  return customFetch<PublicIntakeModeResult>(getSetPublicIntakeModeUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      publicIntakeModeInput,)
  }
);}




export const getSetPublicIntakeModeMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPublicIntakeMode>>, TError,{token: string;data: BodyType<PublicIntakeModeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPublicIntakeMode>>, TError,{token: string;data: BodyType<PublicIntakeModeInput>}, TContext> => {

const mutationKey = ['setPublicIntakeMode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPublicIntakeMode>>, {token: string;data: BodyType<PublicIntakeModeInput>}> = (props) => {
          const {token,data} = props ?? {};

          return  setPublicIntakeMode(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPublicIntakeModeMutationResult = NonNullable<Awaited<ReturnType<typeof setPublicIntakeMode>>>
    export type SetPublicIntakeModeMutationBody = BodyType<PublicIntakeModeInput>
    export type SetPublicIntakeModeMutationError = ErrorType<ApiError>

    /**
 * @summary Choose how to complete the intake (form, chat, or voice) by secure token (no authentication)
 */
export const useSetPublicIntakeMode = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPublicIntakeMode>>, TError,{token: string;data: BodyType<PublicIntakeModeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setPublicIntakeMode>>,
        TError,
        {token: string;data: BodyType<PublicIntakeModeInput>},
        TContext
      > => {
      return useMutation(getSetPublicIntakeModeMutationOptions(options));
    }

export const getChatPublicIntakeUrl = (token: string,) => {




  return `/api/public/intakes/${token}/chat`
}

/**
 * @summary Advance the AI intake conversation by one turn (no authentication)
 */
export const chatPublicIntake = async (token: string,
    publicIntakeChatInput: PublicIntakeChatInput, options?: RequestInit): Promise<PublicIntakeChatResult> => {

  return customFetch<PublicIntakeChatResult>(getChatPublicIntakeUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      publicIntakeChatInput,)
  }
);}




export const getChatPublicIntakeMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatPublicIntake>>, TError,{token: string;data: BodyType<PublicIntakeChatInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof chatPublicIntake>>, TError,{token: string;data: BodyType<PublicIntakeChatInput>}, TContext> => {

const mutationKey = ['chatPublicIntake'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatPublicIntake>>, {token: string;data: BodyType<PublicIntakeChatInput>}> = (props) => {
          const {token,data} = props ?? {};

          return  chatPublicIntake(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChatPublicIntakeMutationResult = NonNullable<Awaited<ReturnType<typeof chatPublicIntake>>>
    export type ChatPublicIntakeMutationBody = BodyType<PublicIntakeChatInput>
    export type ChatPublicIntakeMutationError = ErrorType<ApiError>

    /**
 * @summary Advance the AI intake conversation by one turn (no authentication)
 */
export const useChatPublicIntake = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatPublicIntake>>, TError,{token: string;data: BodyType<PublicIntakeChatInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof chatPublicIntake>>,
        TError,
        {token: string;data: BodyType<PublicIntakeChatInput>},
        TContext
      > => {
      return useMutation(getChatPublicIntakeMutationOptions(options));
    }

export const getSubmitPublicIntakeUrl = (token: string,) => {




  return `/api/public/intakes/${token}/submit`
}

/**
 * @summary Submit a completed intake by secure token (no authentication)
 */
export const submitPublicIntake = async (token: string,
    publicIntakeSaveInput: PublicIntakeSaveInput, options?: RequestInit): Promise<PublicIntakeSubmitResult> => {

  return customFetch<PublicIntakeSubmitResult>(getSubmitPublicIntakeUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      publicIntakeSaveInput,)
  }
);}




export const getSubmitPublicIntakeMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitPublicIntake>>, TError,{token: string;data: BodyType<PublicIntakeSaveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitPublicIntake>>, TError,{token: string;data: BodyType<PublicIntakeSaveInput>}, TContext> => {

const mutationKey = ['submitPublicIntake'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitPublicIntake>>, {token: string;data: BodyType<PublicIntakeSaveInput>}> = (props) => {
          const {token,data} = props ?? {};

          return  submitPublicIntake(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitPublicIntakeMutationResult = NonNullable<Awaited<ReturnType<typeof submitPublicIntake>>>
    export type SubmitPublicIntakeMutationBody = BodyType<PublicIntakeSaveInput>
    export type SubmitPublicIntakeMutationError = ErrorType<ApiError>

    /**
 * @summary Submit a completed intake by secure token (no authentication)
 */
export const useSubmitPublicIntake = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitPublicIntake>>, TError,{token: string;data: BodyType<PublicIntakeSaveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitPublicIntake>>,
        TError,
        {token: string;data: BodyType<PublicIntakeSaveInput>},
        TContext
      > => {
      return useMutation(getSubmitPublicIntakeMutationOptions(options));
    }

export const getListProvidersUrl = () => {




  return `/api/providers`
}

/**
 * @summary List providers for the authenticated account
 */
export const listProviders = async ( options?: RequestInit): Promise<Provider[]> => {

  return customFetch<Provider[]>(getListProvidersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProvidersQueryKey = () => {
    return [
    `/api/providers`
    ] as const;
    }


export const getListProvidersQueryOptions = <TData = Awaited<ReturnType<typeof listProviders>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProviders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProvidersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProviders>>> = ({ signal }) => listProviders({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProviders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof listProviders>>>
export type ListProvidersQueryError = ErrorType<unknown>


/**
 * @summary List providers for the authenticated account
 */

export function useListProviders<TData = Awaited<ReturnType<typeof listProviders>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProviders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProvidersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateProviderUrl = () => {




  return `/api/providers`
}

/**
 * @summary Create a provider
 */
export const createProvider = async (providerInput: ProviderInput, options?: RequestInit): Promise<Provider> => {

  return customFetch<Provider>(getCreateProviderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      providerInput,)
  }
);}




export const getCreateProviderMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProvider>>, TError,{data: BodyType<ProviderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProvider>>, TError,{data: BodyType<ProviderInput>}, TContext> => {

const mutationKey = ['createProvider'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProvider>>, {data: BodyType<ProviderInput>}> = (props) => {
          const {data} = props ?? {};

          return  createProvider(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProviderMutationResult = NonNullable<Awaited<ReturnType<typeof createProvider>>>
    export type CreateProviderMutationBody = BodyType<ProviderInput>
    export type CreateProviderMutationError = ErrorType<ApiError>

    /**
 * @summary Create a provider
 */
export const useCreateProvider = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProvider>>, TError,{data: BodyType<ProviderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProvider>>,
        TError,
        {data: BodyType<ProviderInput>},
        TContext
      > => {
      return useMutation(getCreateProviderMutationOptions(options));
    }

export const getUpdateProviderUrl = (id: number,) => {




  return `/api/providers/${id}`
}

/**
 * @summary Update a provider
 */
export const updateProvider = async (id: number,
    providerUpdate: ProviderUpdate, options?: RequestInit): Promise<Provider> => {

  return customFetch<Provider>(getUpdateProviderUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      providerUpdate,)
  }
);}




export const getUpdateProviderMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProvider>>, TError,{id: number;data: BodyType<ProviderUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProvider>>, TError,{id: number;data: BodyType<ProviderUpdate>}, TContext> => {

const mutationKey = ['updateProvider'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProvider>>, {id: number;data: BodyType<ProviderUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProvider(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProviderMutationResult = NonNullable<Awaited<ReturnType<typeof updateProvider>>>
    export type UpdateProviderMutationBody = BodyType<ProviderUpdate>
    export type UpdateProviderMutationError = ErrorType<ApiError>

    /**
 * @summary Update a provider
 */
export const useUpdateProvider = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProvider>>, TError,{id: number;data: BodyType<ProviderUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProvider>>,
        TError,
        {id: number;data: BodyType<ProviderUpdate>},
        TContext
      > => {
      return useMutation(getUpdateProviderMutationOptions(options));
    }

export const getDeleteProviderUrl = (id: number,) => {




  return `/api/providers/${id}`
}

/**
 * @summary Deactivate/delete a provider
 */
export const deleteProvider = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteProviderUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProviderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProvider>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProvider>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteProvider'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProvider>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteProvider(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProviderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProvider>>>

    export type DeleteProviderMutationError = ErrorType<unknown>

    /**
 * @summary Deactivate/delete a provider
 */
export const useDeleteProvider = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProvider>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProvider>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteProviderMutationOptions(options));
    }

export const getListAppointmentsUrl = (params?: ListAppointmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/appointments?${stringifiedParams}` : `/api/appointments`
}

/**
 * @summary List appointments, optionally filtered by date range and status
 */
export const listAppointments = async (params?: ListAppointmentsParams, options?: RequestInit): Promise<Appointment[]> => {

  return customFetch<Appointment[]>(getListAppointmentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAppointmentsQueryKey = (params?: ListAppointmentsParams,) => {
    return [
    `/api/appointments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAppointmentsQueryOptions = <TData = Awaited<ReturnType<typeof listAppointments>>, TError = ErrorType<unknown>>(params?: ListAppointmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAppointments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAppointmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAppointments>>> = ({ signal }) => listAppointments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAppointments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAppointmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAppointments>>>
export type ListAppointmentsQueryError = ErrorType<unknown>


/**
 * @summary List appointments, optionally filtered by date range and status
 */

export function useListAppointments<TData = Awaited<ReturnType<typeof listAppointments>>, TError = ErrorType<unknown>>(
 params?: ListAppointmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAppointments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAppointmentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAppointmentUrl = () => {




  return `/api/appointments`
}

/**
 * @summary Create an appointment
 */
export const createAppointment = async (appointmentInput: AppointmentInput, options?: RequestInit): Promise<Appointment> => {

  return customFetch<Appointment>(getCreateAppointmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentInput,)
  }
);}




export const getCreateAppointmentMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAppointment>>, TError,{data: BodyType<AppointmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAppointment>>, TError,{data: BodyType<AppointmentInput>}, TContext> => {

const mutationKey = ['createAppointment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAppointment>>, {data: BodyType<AppointmentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAppointment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof createAppointment>>>
    export type CreateAppointmentMutationBody = BodyType<AppointmentInput>
    export type CreateAppointmentMutationError = ErrorType<ApiError>

    /**
 * @summary Create an appointment
 */
export const useCreateAppointment = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAppointment>>, TError,{data: BodyType<AppointmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAppointment>>,
        TError,
        {data: BodyType<AppointmentInput>},
        TContext
      > => {
      return useMutation(getCreateAppointmentMutationOptions(options));
    }

export const getGetAppointmentUrl = (id: number,) => {




  return `/api/appointments/${id}`
}

/**
 * @summary Get an appointment by ID with linked patient, intake, and note detail
 */
export const getAppointment = async (id: number, options?: RequestInit): Promise<AppointmentDetail> => {

  return customFetch<AppointmentDetail>(getGetAppointmentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAppointmentQueryKey = (id: number,) => {
    return [
    `/api/appointments/${id}`
    ] as const;
    }


export const getGetAppointmentQueryOptions = <TData = Awaited<ReturnType<typeof getAppointment>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppointmentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointment>>> = ({ signal }) => getAppointment(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAppointmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointment>>>
export type GetAppointmentQueryError = ErrorType<ApiError>


/**
 * @summary Get an appointment by ID with linked patient, intake, and note detail
 */

export function useGetAppointment<TData = Awaited<ReturnType<typeof getAppointment>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAppointmentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateAppointmentUrl = (id: number,) => {




  return `/api/appointments/${id}`
}

/**
 * @summary Update an appointment (reschedule, change status, edit notes)
 */
export const updateAppointment = async (id: number,
    appointmentUpdate: AppointmentUpdate, options?: RequestInit): Promise<Appointment> => {

  return customFetch<Appointment>(getUpdateAppointmentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentUpdate,)
  }
);}




export const getUpdateAppointmentMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppointment>>, TError,{id: number;data: BodyType<AppointmentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAppointment>>, TError,{id: number;data: BodyType<AppointmentUpdate>}, TContext> => {

const mutationKey = ['updateAppointment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAppointment>>, {id: number;data: BodyType<AppointmentUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAppointment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateAppointment>>>
    export type UpdateAppointmentMutationBody = BodyType<AppointmentUpdate>
    export type UpdateAppointmentMutationError = ErrorType<ApiError>

    /**
 * @summary Update an appointment (reschedule, change status, edit notes)
 */
export const useUpdateAppointment = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppointment>>, TError,{id: number;data: BodyType<AppointmentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAppointment>>,
        TError,
        {id: number;data: BodyType<AppointmentUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAppointmentMutationOptions(options));
    }

export const getDeleteAppointmentUrl = (id: number,) => {




  return `/api/appointments/${id}`
}

/**
 * @summary Delete an appointment
 */
export const deleteAppointment = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAppointmentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAppointmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAppointment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAppointment>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAppointment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAppointment>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAppointment(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAppointment>>>

    export type DeleteAppointmentMutationError = ErrorType<unknown>

    /**
 * @summary Delete an appointment
 */
export const useDeleteAppointment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAppointment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAppointment>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAppointmentMutationOptions(options));
    }

export const getSendAppointmentIntakeUrl = (id: number,) => {




  return `/api/appointments/${id}/send-intake`
}

/**
 * @summary Create and link a patient intake for this appointment, returning one secure link
 */
export const sendAppointmentIntake = async (id: number,
    sendAppointmentIntakeInput: SendAppointmentIntakeInput, options?: RequestInit): Promise<Intake> => {

  return customFetch<Intake>(getSendAppointmentIntakeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendAppointmentIntakeInput,)
  }
);}




export const getSendAppointmentIntakeMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAppointmentIntake>>, TError,{id: number;data: BodyType<SendAppointmentIntakeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendAppointmentIntake>>, TError,{id: number;data: BodyType<SendAppointmentIntakeInput>}, TContext> => {

const mutationKey = ['sendAppointmentIntake'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAppointmentIntake>>, {id: number;data: BodyType<SendAppointmentIntakeInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendAppointmentIntake(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendAppointmentIntakeMutationResult = NonNullable<Awaited<ReturnType<typeof sendAppointmentIntake>>>
    export type SendAppointmentIntakeMutationBody = BodyType<SendAppointmentIntakeInput>
    export type SendAppointmentIntakeMutationError = ErrorType<ApiError>

    /**
 * @summary Create and link a patient intake for this appointment, returning one secure link
 */
export const useSendAppointmentIntake = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAppointmentIntake>>, TError,{id: number;data: BodyType<SendAppointmentIntakeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendAppointmentIntake>>,
        TError,
        {id: number;data: BodyType<SendAppointmentIntakeInput>},
        TContext
      > => {
      return useMutation(getSendAppointmentIntakeMutationOptions(options));
    }

